<template>
  <div>
    <!-- <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Paginated tables</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="neutral">New</base-button>
          <base-button size="sm" type="neutral">Filters</base-button>
        </b-col>
      </b-row>
    </base-header> -->
      <div>
        <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
          <template slot="header">
            <h3 class="mb-0">{{cardTitle}}</h3>
          </template>
          <div class="table-responsive">

            <el-table :data="queriedData"
                      row-key="id"
                      header-row-class-name="thead-light"
                      @sort-change="sortChange"
                      @selection-change="selectionChange"
                      @row-click="handleEdit"
                      >
                    <el-table-column v-for="column in myColumns" :key="column.label" v-bind="column" v-if="column.isVisible == null || column.isVisible" show-overflow-tooltip >
                      
                    </el-table-column>
               <!-- <el-table-column min-width="180px" align="right" label="Actions">
                <div slot-scope="{$index, row}" class="d-flex">
                  <base-button
                    @click.native="handleEdit($index, row)"
                    
                    class="edit"
                    type="warning"
                    size="sm"
                    icon
                  >
                    <i class="text-white fas fa-edit"></i>
                  </base-button>
                  <base-button
                    @click.native="handleDelete($index, row)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="text-white ni ni-fat-remove"></i>
                  </base-button> 
                </div>
              </el-table-column>  -->
            </el-table>
          </div>
          <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{selectedRows.length}} rows selected
                </span>
              </p>

            </div>
            <base-pagination
              class="pagination-no-border"
              :current="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
              @change="paginationChanged($event)"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from 'element-ui';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import { BasePagination } from '@/components';
import clientPaginationMixin from './PaginatedTables/clientPaginationMixin'

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  props: {
    cardTitle: {
      type: String,
      default: 'Search Results',
      description: 'Search Results Table',
      required:true
    },
    myColumns:{
      type:Array,
      default: function () { return [] },
      required:true
    },
    tableData:{
      type:Array,
      default: function () { return [] },
      required:true
    }
  },
  data() {
    return {
      propsToSearch: ['name', 'email', 'age'],
      selectedRows: []
    };
  },
  methods: {

    changeRowColor(row, column, cell, event) {
      console.log(row)
      console.log(column)
      console.log(cell)
    },
    paginationChanged(page) {
      this.pagination.currentPage = page
    },
    handleEdit(row) {

      if(row)
      {
        let code = encodeURIComponent(row.code)

          let current_path_name = this.$route.name
          if(current_path_name == 'CUSTOMERS'){
              this.$router.push("/sales/customer/" + code)
          }
          else if(current_path_name == 'SALES'){
              this.$router.push("/sales/sales-document/" + code)
          }
          else if(current_path_name == 'SALES_QUOTATIONS'){
              // this.$router.push("/sales/sales-quotation/" + code)
              let url = '/sales/sales-quotation/' + encodeURIComponent(code)
              window.open(url , '_blank');              
          }
          else if(current_path_name == 'SALES_ORDERS'){
              this.$router.push("/sales/sales-order/" + code)
          }
          else if(current_path_name == 'SALES_INVOICES'){
              // this.$router.push("/sales/sales-invoice/" + code)
              let url = '/sales/sales-invoice/' + encodeURIComponent(code)
              window.open(url , '_blank');
          }
          else if(current_path_name == 'PRODUCT_MASTER')
          {
              this.$router.push("/products/detail/" + code)
          }
          else if(current_path_name == 'SALE_CHANNELS')
          {
              this.$router.push("/sales/salechannel/" + code)
          }
          else if(current_path_name == 'SALES_RECEIPTS')
          {
            this.$router.push("/finance/sales-receipt/" + code)
          }
          else if(current_path_name == 'LOCATIONS')
          {
            this.$router.push("/inventory/location/" + code)
          }
          else if(current_path_name == 'STOCKCARDS')
          {
            this.$router.push("/inventory/stockcard-details/" + code)
          }
          else if(current_path_name == 'VENDORS')
          {
            this.$router.push("/purchase/vendor/" + code)
          }
          else if(current_path_name == 'PURCHASE_ORDERS')
          {
            // this.$router.push("/purchase/purchase-order/" + code)
            let url = '/purchase/purchase-order/' + encodeURIComponent(code)
            window.open(url , '_blank');            
          }
          else if(current_path_name == 'PURCHASE_INVOICES')
          {
            // this.$router.push("/purchase/purchase-invoice/" + code)
            let url = '/purchase/purchase-invoice/' + encodeURIComponent(code)
            window.open(url , '_blank');            

          }
          else if(current_path_name == 'OVERVIEW')
          {
            this.$emit("showDetails", row);
          }
          else if(current_path_name == 'GOOD_RECEIVE_NOTES')
          {
            //this.$router.push("/inventory/grn/" + code)
          }
          else if(current_path_name == 'DELIVERY_ORDERS')
          {
            this.$router.push("/inventory/do/" + code)
          }
          else if(current_path_name == 'USER_MASTER')
          {
            this.$router.push("/users/detail/" + row.handle)
          }
          else if(current_path_name == 'VOUCHERS')
          {
            this.$router.push("/finance/voucher/" + row.voucher_code)
          }
          else if(current_path_name == 'GL_VOUCHERS')
          {
            this.$router.push("/finance/gl-voucher/" + row.voucher_code)
          }
          else if(current_path_name == 'STOCK_TRANSFERS')
          {
            this.$router.push("/inventory/stocktransfer/" + code)
          }
          else if(current_path_name == 'CASE_TYPES')
          {
              this.$router.push("/case-management/case-types/" + code)
          }
          else if(current_path_name == 'CASES')
          {
              this.$router.push("/case-management/case/" + code)
          }
          else if(current_path_name == 'CONTACT_CATEGORIES')
          {
              this.$router.push("/settings/contact-categories/" + code)
          }
          else if(current_path_name == 'SYSTEM_SETTINGS')
          {
              this.$router.push("/settings/system-settings/" + code)
          }
          else if(current_path_name == 'ASSETS')
          {
              this.$router.push("/assets-management/asset/" + code)
          }
          else if(current_path_name == 'RFIDS_MASTER')
          {
              this.$router.push("/rfids/details/" + code)
          }
          else if(current_path_name == 'ASSET_CLASSIFICATIONS')
          {
            this.$router.push("/assetclassifications-management/details/" + code)
          }
          else if(current_path_name == 'ASSET_PROTOCOLS')
          {
            this.$router.push("/assetprotocols-management/details/" + code)
          }
          else if(current_path_name == 'PRODUCT_CATEGORIES')
          {
              this.$router.push("/settings/product-categories/" + code)
          }
          else if(current_path_name == 'STOCKADJUSTMENTS')
          {
            this.$router.push("/inventory/stockadjustment/" + code)
          }
          else if(current_path_name == 'PURCHASE_RECEIPTS')
          {
            this.$router.push("/finance/purchase-receipt/" + code)
          }
          else
          {
            alert(current_path_name)
          }
        }
    },
    handleDelete(index, row) 
    {
      console.log(index)
      console.log(row)
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows
    }
  }
};
</script>
<style>
  .no-border-card .card-footer{
    border-top: 0;
  }
</style>
